import React from 'react';

import { DEFAULT_ICON_PROPS, IIconProps } from './constants';

export const CheckFillCircleIcon = ({ ariaLabel = 'CheckFill', ...props }: IIconProps) => {
  const { size, width, height, title, ariaHidden, className } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };

  return (
    <svg
      width={size || width}
      height={size || height}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ariaLabel}
      aria-hidden={ariaHidden}
      className={`block ${className}`}
      {...props}
    >
      {title && <title>{title}</title>}
      <path
        d="M8.39167 13.5845L13.9729 8.0033L12.8646 6.89496L8.39167 11.3679L6.13542 9.11163L5.02709 10.22L8.39167 13.5845ZM9.5 17.8595C8.40486 17.8595 7.3757 17.6517 6.4125 17.2361C5.44931 16.8205 4.61146 16.2564 3.89896 15.5439C3.18646 14.8314 2.6224 13.9936 2.20677 13.0304C1.79115 12.0672 1.58334 11.038 1.58334 9.94288C1.58334 8.84774 1.79115 7.81858 2.20677 6.85538C2.6224 5.89219 3.18646 5.05434 3.89896 4.34184C4.61146 3.62934 5.44931 3.06528 6.4125 2.64965C7.3757 2.23403 8.40486 2.02621 9.5 2.02621C10.5951 2.02621 11.6243 2.23403 12.5875 2.64965C13.5507 3.06528 14.3885 3.62934 15.101 4.34184C15.8135 5.05434 16.3776 5.89219 16.7932 6.85538C17.2089 7.81858 17.4167 8.84774 17.4167 9.94288C17.4167 11.038 17.2089 12.0672 16.7932 13.0304C16.3776 13.9936 15.8135 14.8314 15.101 15.5439C14.3885 16.2564 13.5507 16.8205 12.5875 17.2361C11.6243 17.6517 10.5951 17.8595 9.5 17.8595ZM9.5 16.2762C11.2681 16.2762 12.7656 15.6627 13.9927 14.4356C15.2198 13.2085 15.8333 11.7109 15.8333 9.94288C15.8333 8.17483 15.2198 6.67726 13.9927 5.45017C12.7656 4.22309 11.2681 3.60955 9.5 3.60955C7.73195 3.60955 6.23438 4.22309 5.00729 5.45017C3.78021 6.67726 3.16667 8.17483 3.16667 9.94288C3.16667 11.7109 3.78021 13.2085 5.00729 14.4356C6.23438 15.6627 7.73195 16.2762 9.5 16.2762Z"
        fill="currentColor"
      />
    </svg>
  );
};
